import { render, staticRenderFns } from "./LayoutSms.vue?vue&type=template&id=e090fca6&"
import script from "./LayoutSms.vue?vue&type=script&lang=js&"
export * from "./LayoutSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports